<mat-tab-group class="od-services-tab">
  @if (serviceData(); as data) {
    @for (service of data.servicios; track service.id; let i = $index) {
      <mat-tab [label]="'Servicio ' + (i + 1) + ' de ' + data.servicios.length">
      <div class="od-services-tab__container">
        <app-service-cancellation-alert
          [currentState]="service.estadoHomologado || service.lastTracking?.state || service.estado"
          [currentStateDate]="getCancellationDate(service)"
          [reasonText]="state.getServiceTrackingObservation(service)">
        </app-service-cancellation-alert>
        <div class="od-services-tab__timeline">
          <app-service-timeline
            [serviceDetailId]="service.serviceDetailId"
            (viewMore)="onViewMoreTimelineDetail($event)"
            (lastStepDateChange)="onTimelineDateChange(service.id, $event)">
          </app-service-timeline>
        </div>
        <div class="od-services-tab__row">
          <div class="od-services-tab__column od-services-tab__column--left">
            <div class="od-services-tab__section">
              <div class="od-services-tab__section__title">
                <mat-icon>assignment</mat-icon>
                <span>ORDEN DE SERVICIO: {{ service.id }}</span>
              </div>
              <div class="od-services-tab__section__info">
                <div class="od-services-tab__section__row">
                  <span class="row__title">Nombre</span>
                  <span class="row__text">{{ service.descripcion}}</span>
                </div>
                <div class="od-services-tab__section__row">
                  <span class="row__title">Fecha de registro</span>
                  <span class="row__text">{{ data.fechaRegistro | date: 'dd/MM/yy' }}</span>
                </div>
                <div class="od-services-tab__section__row">
                  <span class="row__title">Fecha estimada</span>
                  <span class="row__text">
                    <mat-icon [class]="utilService.getClassIconTimer(data.fechaEstimada)">timer</mat-icon>
                    {{(data.fechaEstimada|date:'dd/MM/YY')||'-'}}
                  </span>
                </div>
                <div class="od-services-tab__section__row">
                  <span class="row__title">Turno estimado</span>
                  <span class="row__text">{{ data.turnoEstimado }}</span>
                </div>
                <div class="od-services-tab__section__row">
                  <span class="row__title">Sucursal de registro</span>
                  <span class="row__text">{{ data.sucursalRegistro }}</span>
                </div>
                <div class="od-services-tab__section__row">
                  <span class="row__title">Estado</span>
                  <span class="row__text">{{ service.estadoHomologado || service.estado }}</span>
                </div>
                <div class="od-services-tab__section__row">
                  <span class="row__title">Dirección</span>
                  <span class="row__text">{{ data.cliente.direccion || '-' }}</span>
                </div>
              </div>
              <div class="od-services-tab__section__actions">
                @if (data.options && data.options.availableReschedule) {
                <button mat-stroked-button class="actions__blue" (click)="onOpenServiceRescheduleDrawer($event, service)">REPROGRAMAR SERVICIO</button>
                }
                @if (data.options && data.options.availableCancellation) {
                <button mat-stroked-button class="actions__red" (click)="onOpenServiceCancelDrawer($event, service)">ANULAR SERVICIO</button>
                }
                @if (hasVisits()) {
                <button mat-stroked-button class="actions__yellow" (click)="onOpenVisitsDrawer($event, service)">VER VISITAS</button>
                }
              </div>
            </div>
          </div>
          <div class="od-services-tab__column od-services-tab__column--right">
            <div class="od-services-tab__section">
              <div class="od-services-tab__section__title">
                <mat-icon>groups</mat-icon>
                <span>DATOS DEL PROVEEDOR</span>
              </div>
              <div class="od-services-tab__section__info">
                <div class="od-services-tab__section__row">
                  <span class="row__title">Proveedor</span>
                  <span class="row__text">{{ data.proveedor.ruc }} - {{ data.proveedor.razonSocial }}</span>
                </div>
                <div class="od-services-tab__section__row">
                  <span class="row__title">Técnico</span>
                  <span class="row__text">{{ technicianName() ?? '-' }}</span>
                </div>
                <div class="od-services-tab__section__row">
                  <span class="row__title">Tipo de proveedor</span>
                  <span class="row__text">{{ data.tipo || '-' }}</span>
                </div>
              </div>
            </div>
            <div class="od-services-tab__section">
              <div class="od-services-tab__section__row od-services-tab__section__row--header">
                <div class="od-services-tab__section__title">
                  <mat-icon>build</mat-icon>
                  <span>PRODUCTOS</span>
                  <span class="badge">{{ service.productos.length }}</span>
                </div>
                <button mat-button
                  class="od-services-tab__section__button"
                  [class.od-services-tab__section__button--empty]="!service.imagenes || service.imagenes.length === 0"
                  [disabled]="!service.imagenes || service.imagenes.length === 0"
                  (click)="onOpenImagesCarouselDialog($event, service.imagenes)">
                  <mat-icon fontSet="material-icons-outlined">
                    {{ (!service.imagenes || service.imagenes.length === 0) ? 'no_photography' : 'photo_camera' }}
                  </mat-icon>
                  VER IMÁGENES
                </button>
              </div>

              <table mat-table [dataSource]="service.productos" class="od-services-tab__table">
                <ng-container matColumnDef="sku">
                  <th mat-header-cell *matHeaderCellDef>SKU</th>
                  <td mat-cell *matCellDef="let element">{{ element.sku }}</td>
                </ng-container>

                <ng-container matColumnDef="producto">
                  <th mat-header-cell *matHeaderCellDef>Producto</th>
                  <td mat-cell *matCellDef="let element">{{ element.descripcion }}</td>
                </ng-container>

                <ng-container matColumnDef="cantidad">
                  <th mat-header-cell *matHeaderCellDef>Cantidad</th>
                  <td mat-cell *matCellDef="let element">{{ element.cantidad }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
        </div>

      </div>
      </mat-tab>
    }
  }
</mat-tab-group>
